const nl = {
    accepted: 'Het :attribute veld moet geaccepteerd worden.',
    after: ':attribute moet een datum na :after zijn.',
    after_or_equal: 'De :attribute datum moet op of na :after_or_equal zijn.',
    alpha: 'Het :attribute veld mag alleen maar letters bevatten.',
    alpha_dash: 'Het :attribute veld mag alleen maar letters, cijfers en (liggende) streepjes bevatten.',
    alpha_num: 'Het :attribute veld mag alleen maar letters en cijfers bevatten.',
    attributes: {},
    before: ':attribute moet vòòr :before zijn.',
    before_or_equal: ':attribute moet vòòr of op :before_or_equal zijn.',
    between: 'Het :attribute veld moet tussen :min en :max liggen.',
    confirmed: 'Het :attribute veld komt niet met de bevestiging overeen.',
    email: 'Het :attribute formaat is ongeldig.',
    date: 'Het :attribute veld moet een geldige datum zijn.',
    def: 'Het :attribute veld bevat fouten.',
    digits: 'Het :attribute veld moet :digits cijfers hebben.',
    digits_between: ':attribute moet bestaan uit minimaal :min en maximaal :max cijfers.',
    different: 'Het :attribute en :different veld moeten verschillend zijn.',
    in: 'De gekozen waarde voor :attribute is ongeldig.',
    integer: 'Het :attribute veld moet een geheel getal zijn.',
    hex: 'Het :attribute veld moet hexadecimaal zijn',
    min: {
        numeric: 'Het :attribute veld moet minstens :min zijn.',
        string: 'Het :attribute veld moet minstens :min karakters bevatten.',
    },
    max: {
        numeric: 'Het :attribute veld mag maximaal :max zijn.',
        string: 'Het :attribute veld mag niet meer dan :max karakters bevatten.',
    },
    not_in: 'De gekozen waarde voor :attribute is ongeldig.',
    numeric: 'Het :attribute veld moet een getal zijn.',
    present: 'Het :attribute veld moet aanwezig zijn (maar mag leeg zijn).',
    required: 'Het :attribute veld moet ingevuld zijn.',
    required_if: 'Het :attribute veld moet ingevuld zijn, wanneer :other :value is.',
    required_unless: 'Het :attribute veld moet ingevuld zijn, wanneer :other niet :value is.',
    required_with: 'Het :attribute veld moet ingevuld zijn, wanneer :field niet leeg is.',
    required_with_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields niet leeg zijn.',
    required_without: 'Het :attribute veld moet ingevuld zijn, wanneer :field leeg is.',
    required_without_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields leeg zijn.',
    same: 'De :attribute en :same velden moeten overeenkomen.',
    size: {
        numeric: 'Het :attribute veld moet :size zijn.',
        string: 'Het :attribute veld moet :size karakters bevatten.',
    },
    string: 'Het :attribute veld moet een woord of zin zijn.',
    url: 'Het :attribute veld heeft een ongeldig formaat.',
    regex: 'Het :attribute veld heeft een ongeldig formaat.',
};
export default nl;
